import { render, staticRenderFns } from "./JobsMonitorJobList.vue?vue&type=template&id=0665d502&scoped=true&"
import script from "./JobsMonitorJobList.vue?vue&type=script&lang=js&"
export * from "./JobsMonitorJobList.vue?vue&type=script&lang=js&"
import style0 from "./JobsMonitorJobList.vue?vue&type=style&index=0&id=0665d502&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0665d502",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VDivider,VIcon,VPagination,VTextField})
